/**
 * @description: 千分位转换
 * @param {*} str string类型
 * @return {*} '12,345,678'
 */
export function toThousandths(str) {
  const reg = /(?=\B(\d{3})+$)/g

  return str.replace(reg, ',')
}
